(function($) {

	'use strict';

	var init = function() {

        buttonStickyHandler();

	};


    var buttonStickyHandler = function() {
        

        if(window.matchMedia("(max-width: 1320px)").matches) {

            $('.buttonsSticky__contact').hide();
            $('.buttonsSticky__demo').hide();
            $('.buttonsSticky__brand').hide();
            $('.buttonsSticky__blank').click(function(){
                $('.buttonsSticky__blank').toggleClass('active');
                $('.buttonsSticky__contact').toggle();
                $('.buttonsSticky__demo').toggle();
                $('.buttonsSticky__brand').toggle();
            })
        } else {
            $('.buttonsSticky__contact').show();
            $('.buttonsSticky__demo').show();
            $('.buttonsSticky__brand').show();
        }

    }

	

	$(document).ready(function() {
        init();

        $(window).resize(function(){
            buttonStickyHandler();
        });
	});

    


})(jQuery);
